<template v-cloak>
    <div class="pt402">
        <breadcrumb :navListCustom="[{title:'マイページ', routerName: pt402DoInit.myPage, param: {pageNo: '81'}}
            ,{title:$t('pt402.labels.creditUpdate'), routerName: '', param: {}}]">
        </breadcrumb>
        <div class="section page-mypage mb32">
            <!-- マイページ -->
            <h2>{{$t('pt402.labels.creditUpdate')}}</h2>
            <div class="section-inner">
                <!-- お支払い方法の選択 -->
                <h3 v-if="pt402DoInit.cardNo != undefined && pt402DoInit.cardNo != ''">{{$t('pt402.labels.creditUpdate')}}</h3>
                <h3 v-else>{{$t('pt402.labels.creditInsert')}}</h3>
                <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="'pt402'"/>
                <!-- Message1 -->

                <iframe name="dummyframe" id="dummyframe" ref="dummyframe" style="display:none"></iframe>

                <table class="personal mb32">
                    <tbody>
                        <!--登録済のクレジットカード-->
                        <tr v-if="pt402DoInit.cardNo != undefined && pt402DoInit.cardNo != ''">
                            <th>
                                <label :for="'_siharai_hoho_kbn_1'" onClick="">
                                    <strong>{{$t('pt402.labels.oldCredit')}}</strong>
                                </label>
                                
                            </th>
                            <td>
                                <table v-if="pt402ReqModel.kessaiCompKbn == 'JCS' || pt402ReqModel.kessaiCompKbn == 'SGP' || pt402ReqModel.kessaiCompKbn == 'GMO' || pt402ReqModel.kessaiCompKbn == 'PAY' || pt402ReqModel.kessaiCompKbn == 'SBP'" class="oldCard w-100">
                                    <tr>
                                        <td>
                                            {{ pt402DoInit.cardNo }}<br/>
                                            {{ pt402DoInit.cardLimitMM }}/{{ pt402DoInit.cardLimitYYYY }}
                                        </td>
                                        <td class="cardDel" style="text-align:right;vertical-align: middle;">
                                            <input type="button" id="btnDel" :value="$t('pt402.buttons.delete')" :alt="$t('pt402.buttons.delete')" @click="confirmUpdate(2)" class="submit-button btn-del">
                                        </td>
                                    </tr>
                                </table>
                                <template v-else>
                                    {{ pt402DoInit.cardNo }}<br/>
                                    {{ pt402DoInit.cardLimitMM }}/{{ pt402DoInit.cardLimitYYYY }}
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <th class="register-check w200">
                                <label :for="'_siharai_hoho_kbn_2'" onClick="">
                                    <strong>{{$t("pt402.labels.newCredit")}}</strong>
                                </label>
                            </th>
                            <td v-if="showFlg">
                                <table class="sh060tbl" width="100%" style="width:100%" :summary="$t('sh060.labels.cardnumber')">
                                    <form :action="pt402DoInit.serverUrl" 
                                        METHOD="POST" ref="form" name="form" ENCTYPE="application/x-www-form-urlencode" target="dummyframe">
                                        <input type="hidden" id="userId" :value="pt402DoInit.kokyakuNo"/>
                                        <input type="hidden" id="mail" :value="pt402DoInit.kokyakuMail1"/>
                                        <input type="hidden" id="TelNo" :value="pt402DoInit.kokyakuTel1"/>
                                        <input type="hidden" id="cardNo" :value="pt402ReqModel.cardNoDisp1 + pt402ReqModel.cardNoDisp2 + pt402ReqModel.cardNoDisp3 + pt402ReqModel.cardNoDisp4"/>
                                        <input type="hidden" id="cardLimit" :value="pt402ReqModel.limitMonth + pt402ReqModel.limitYear"/>
                                        <input v-if="pt402DoInit.cardNameOption == 1" type="hidden" id="cardHolder" :value="pt402ReqModel.cardNameNamae + pt402ReqModel.cardNameMyouji"/>
                                        <input v-else type="hidden" id="cardHolder" :value="pt402ReqModel.cardUserNm"/>
                                        <input type="hidden" name="tourokuKbn" value="4">    <!-- 登録区分 -->
                                        <input type="hidden" name="merchantId" :value="pt402DoInit.merchantId">    <!-- 加盟店ID -->
                                        <input type="hidden" name="dbKey1" :value="pt402DoInit.newDbKey">    <!-- 加盟店ID -->
                                        <input type="hidden" name="backUrl" :value="pt402DoInit.backUrl">    <!-- 戻りURL -->
                                        <input type="hidden" name="cardKbn" value="9">    <!-- カード情報返却区分 -->
                                        <input type="hidden" name="optionalAreaName1" value="coNo">
                                        <input type="hidden" name="optionalAreaValue1" :value="pt402DoInit.coNo">    <!-- 会社NO -->
                                        <input type="hidden" name="optionalAreaName2" value="kessaiCd">
                                        <input type="hidden" name="optionalAreaValue2" :value="1">    <!-- 決済方法CD -->
                                        <input type="hidden" name="msgDigest" :value="pt402DoInit.msgDigest">    <!-- 注文受付メッセージダイジェスト -->
                                        
                                        <input type="hidden" name="pan" :value="pan">
                                        <input type="hidden" name="expiryDate" :value="expiryDate">
                                    </form>
                                    <form v-if="pt402ReqModel.kessaiCompKbn == 'SPS'" :action="pt402DoInit.serverUrl" method="POST" ref="formSps3D" id="formSps3D" name="formSps3D" target="_self">
                                        <input type="hidden" name="MerchantId" v-model="sps3DSAuthori.merchantId">
                                        <input type="hidden" name="EncryptValue" v-model="sps3DSAuthori.encValue">
                                    </form>

                                    <tr>
                                        <th>
                                            <!-- カード番号 -->
                                            {{$t('sh060.labels.cardnumber')}}
                                        </th>
                                        <td v-if="pt402DoInit.creditInpNumOption == 0">
                                            <input-check type="tel" class="num" size="4" style=" width:80px;"
                                                :maxlength="4" v-model="pt402ReqModel.cardNoDisp1" autocomplete="off" />
                                            -
                                            <input-check type="tel" class="num" size="4" style=" width:80px;"
                                                :maxlength="4" v-model="pt402ReqModel.cardNoDisp2" autocomplete="off" />
                                            -
                                            <input-check type="tel" class="num" size="4" style=" width:80px;"
                                                :maxlength="4" v-model="pt402ReqModel.cardNoDisp3" autocomplete="off" />
                                            -
                                            <input-check type="tel" class="num" size="4" style=" width:80px;"
                                                :maxlength="4" v-model="pt402ReqModel.cardNoDisp4" autocomplete="off" />
                                        </td>
                                        <td v-else>
                                            <input-check type="tel" class="num" size="20" style=" width:50px;"
                                                :maxlength="20" v-model="pt402ReqModel.cardNoDisp" autocomplete="off" @on-input-change="onCredit" @input="onCredit"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <!-- 有効期限 -->
                                            {{$t('sh060.labels.expirationdate')}}
                                        </th>
                                        <td v-if="pt402DoInit.ymPulldownFlg == 1">
                                            <select v-model="pt402ReqModel.limitMonth" name="limitMonth" id="limitMonth" class="cardPayCnt">
                                                <option v-for="payCnt in pt402DoInit.monKbnList" :key="payCnt.KEY" :value="payCnt.KEY">{{payCnt.VALUE}}</option>
                                            </select>/
                                            <select v-model="pt402ReqModel.limitYear" name="limitYear" id="limitYear" class="cardPayCnt">
                                                <option v-for="payCnt in pt402DoInit.yearList" :key="payCnt.KEY" :value="payCnt.KEY">{{payCnt.VALUE}}</option>
                                            </select>
                                        </td>
                                        <td v-else>
                                            <input-check type="tel" class="num" size="2"
                                                maxlength="2" v-model="pt402ReqModel.limitMonth"
                                                name="limitMonth" id="limitMonth" autocomplete="off" @on-input-change="onBlur"/>
                                                <!-- 月／20 -->
                                                {{$t('sh060.labels.month')}}／20
                                            <input-check type="tel" class="num" size="2"
                                                maxlength="2" v-model="pt402ReqModel.limitYear"
                                                name="limitYear" id="limitYear"
                                                onKeyPress="_chkInp();" autocomplete="off" />
                                                <!-- 年 -->
                                                {{$t('sh060.labels.year')}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <!--カードの名義人 -->
                                        <th>
                                            {{$t('sh060.labels.cardHolder')}}
                                        </th>
                                        <td v-if="pt402DoInit.cardNameOption == 1">
                                            <span v-html="descriptionInfo['1']"></span>
                                            <!-- 名前 -->
                                            <input-check type="text"
                                                size="10"
                                                name="cardNameNamae"
                                                maxlength="50"
                                                class="code" id="cardNameNamae"
                                                v-model="pt402ReqModel.cardNameNamae"
                                                autocomplete="off" :placeholder="descriptionInfo[6]"/>
                                            <span v-html="descriptionInfo['2']"></span>
                                            <input-check type="text" size="10" maxlength="50"
                                                name="cardNameMyouji" class="code" id="cardNameMyouji"
                                                v-model="pt402ReqModel.cardNameMyouji"
                                                autocomplete="off" :placeholder="descriptionInfo[7]"/>
                                            <br />
                                            <span v-html="descriptionInfo['3']"></span>
                                        </td>
                                        <td v-else>
                                            <!-- 名前 -->
                                            <input type="text" size="20" name="cardUserNm"
                                                maxlength="100" id="cardUserNm"
                                                v-model="pt402ReqModel.cardUserNm" autocomplete="off" :placeholder="descriptionInfo[5]"/>
                                            <span v-html="descriptionInfo['3']"></span>
                                        </td>
                                    </tr>
                                    <tr v-if="pt402DoInit.securityCodeUseFlg">
                                        <th>
                                            <!-- セキュリティコード -->
                                            {{$t('sh060.labels.securitycode')}}
                                        </th>
                                        <td>
                                            <input-check type="text" size="4" maxlength="4" name="cardSecurity" class="numcode"
                                                id="cardSecurity"
                                                v-model="pt402ReqModel.securityCode"
                                                autocomplete="off"/>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <ul style="text-align: center;">
                    <li v-if="pt402DoInit.teikiOpt == 1">
                        <span v-html="descriptionInfo[4]"></span>
                    </li>
                </ul>
                <!-- ASUKA準備完了までのメッセージ -->
                <ul class="loadingAsukaMessage text-danger mt-3 mb-3" style="text-align: center;">
                    <li v-if="pt402DoInit.asukaOptionFlg == 1 && !isAsukaReadyToScore">
                        {{$t('common.messages.loadingAsuka')}}
                    </li>
                </ul>
                <ul class="button-column mb32">
                    <!--戻るボタン-->
                    <li>
                        <input type="button" :value="$t('common.buttons.return')" :alt="$t('common.buttons.return')" @click="backPage" class="submit-button back-btn">
                    </li>
                    <!--登録ボタン-->
                    <li v-if="showFlg && isSubmitButton">
                        <input type="button" :value="$t('pt402.buttons.insert')" :alt="$t('pt402.buttons.insert')" @click="confirmUpdate(1)" class="submit-button decision">
                    </li>
                </ul>
            </div>
            <!-- modal confirm area -->
            <alert-confirm 
                v-if="isModalShow"
                :msgConfirm="msgConfirm"
                :okAction="doAction"
                @closedModal="isModalShow = false">
            </alert-confirm>
        </div>
    </div>
</template>
<script>

/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";
import EventBus from 'assets/js/eventBus';
import Message from 'components/MessageEcSite';
import SiteConstants from 'assets/const/SiteConstants.json';
import Constants from 'assets/const/Constants.json';
import InputNumber from "components/InputNumber";
import InputCheck from 'components/InputCheck.vue';
import Breadcrumb from "../commonParts/Breadcrumb";
import Loading from 'vue-loading-overlay';
import AlertConfirm from 'components/AlertConfirm';
import toastr from "toastr/toastr.js";
import "toastr/build/toastr.min.css";
import $ from 'jquery';

toastr.options = {
  closeButton: true,
  positionClass: "toast-top-right",
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "3000",
};

export default {
    /* 
    * Name of component
    */
    name: "PT402CreditChangeParts",
    /* 
    * Get data from parent component
    */
    props:{
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    components:
    {
		EventBus,
		Message,
		InputNumber,
        InputCheck,
        Loading,
        Breadcrumb,
        AlertConfirm,
        toastr
    },
    data() {
        return {
            isBunkatu:false,
            isModalShow: false,
            isButtonCancel:true,
            msgConfirm: '',
            pt402DoInit:{
                cardNo : '',
                index : ''
            },
            listIdErr:[],
            pt402ReqModel:{},
            descriptionInfo:null,
            SiteConstants: SiteConstants,
            Constants: Constants,
            PT402_PART:'pt402',
            listMessValid:[],
            mapMessValid:[],
            site: "",
            timer: '',
            showFlg: false,
            sps3DSAuthori: {
                encValue: '',
                merchantId: '',
            },
            isSubmitButton: false,
            isAsukaReadyToScore: false,
            securitySbp3DFlg: 0,
            sbpTdsAuthenticationId: '',
            sbpEmv3dsStatus: '',
            sbpErrorCode: '',
            securityGmo3DFlg: 0,
            resGmoVer2ACS: '',
            resGmoVer2RedirectUrl: '',
            gmo2AuthAccessID: '',
            gmoAccess: '',
            gmoCustCd: '',
            gmoOrderCd: '',
            currPageNo: ''
        }
    },
    mounted() {
        var _this = this;

        if (_this.ptInitData){
            _this.pt402DoInit = _this.ptInitData;
            // 未ログインの場合
            if (!_this.pt402DoInit.isLogin) {
                // ログイン画面へ遷移
                const parameter = _this.generateLinkParams(18, _this.pt402DoInit.loginPage, {returnFlg: 1, fromMyPage: 1});
                _this.$router.push(parameter);
            }
        }else{
            window.addEventListener('as-readytoscore', function() {
                _this.isAsukaReadyToScore = true;
            });

            _this.init();
        }
    },
    methods: {
        /*
        * 初期処理
        */
        init: function() {
            var _this = this;
            _this.site = _this.$router.history.current.fullPath.split("/")[1];
            _this.pt402ReqModel.clientHost = window.location.protocol + "//" + window.location.host;

            // eslint-disable-next-line
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT402 + _this.$UrlConstants.DO_INIT ,_this.pt402ReqModel).then(function(response) {
                _this.pt402DoInit = response.data;

                // 未ログインの場合
                if (!_this.pt402DoInit.isLogin) {
                    // ログイン画面へ遷移
                    const parameter = _this.generateLinkParams(18, _this.pt402DoInit.loginPage, {returnFlg: 1, fromMyPage: 1});
                    _this.$router.push(parameter);
                }
                _this.pt402SiharaiHohoKbnList = response.data.resultSiharaiHohoKbnList;
                _this.pt402ReqModel = $.extend(_this.pt402ReqModel, response.data.reqModel);
                _this.descriptionInfo = _this.pt402DoInit.descriptionInfo;
                _this.securitySbp3DFlg = _this.pt402DoInit.securitySbp3DFlg
                _this.securityGmo3DFlg = _this.pt402DoInit.securityGmo3DFlg;//gmo

                if (_this.pt402DoInit.payCntList.length > 0) {
                    _this.pt402ReqModel.cardPayCnt = _this.pt402DoInit.payCntList[0]['KEY'];
                }

                for (let i = 0; i < _this.pt402SiharaiHohoKbnList.length; i++) {
                    if (_this.pt402SiharaiHohoKbnList[i].KEY == "1") {
                        _this.pt402ReqModel.kessaiCompKbn = _this.pt402SiharaiHohoKbnList[i].KESSAI_COMP_KBN;
                        break;
                    }
                }

                if (_this.pt402DoInit.cardNo != '') {
                    _this.pt402ReqModel.cardFlg = 1;
                } else {
                    _this.pt402ReqModel.cardFlg = 0;
                }
                _this.showFlg = true;

                // ASUKAチェック
                if (_this.pt402DoInit.asukaOptionFlg == 1) {
                    // ASUKAを使用している場合、準備ができていればtrueにする
                    if (_this.isAsukaReadyToScore || window.asukaAlready) {
                        _this.isSubmitButton = true;
                        _this.isAsukaReadyToScore = true;
                    } else {
                        _this.reCheckAsukaReadyToScore();
                    }
                } else {
                    // ASUKAを使用していない場合はtrueにする
                    _this.isSubmitButton = true;
                }

                // sps 3d
                if (_this.spsResultId) {
                    if (_this.pt402ReqModel.orderCdTypical == null || _this.pt402ReqModel.orderCdTypical == "") {
                        _this.pt402ReqModel.orderCdTypical = sessionStorage.getItem('orderCdTypical');
                    }
                    if (_this.pt402ReqModel.orderCd == null || _this.pt402ReqModel.orderCd == "") {
                        _this.pt402ReqModel.orderCd = sessionStorage.getItem('orderCd');
                    }
                    if (_this.pt402ReqModel.teikiFlg == null || _this.pt402ReqModel.teikiFlg == "") {
                        _this.pt402ReqModel.teikiFlg = sessionStorage.getItem('teikiFlg');
                    }
                    if (_this.pt402ReqModel.teikiNo == null || _this.pt402ReqModel.teikiNo == "") {
                        _this.pt402ReqModel.teikiNo = sessionStorage.getItem('teikiNo');
                    }
                    if (_this.pt402ReqModel.backPageNo == null || _this.pt402ReqModel.backPageNo == "") {
                        _this.pt402ReqModel.backPageNo = sessionStorage.getItem('backPageNo');
                    }

                    _this.pt402ReqModel.siharaiHohoKbn = '1';
                    _this.pt402ReqModel.spsResultId = _this.spsResultId;
                    _this.update();
                }

                //sbp 3d
                if (_this.sbpEmv3dsStatus) {
                    if (sessionStorage['sbp_ccdd']){
                        _this.pt402ReqModel.resSbpCustId = sessionStorage['sbp_ccdd'];
                    }
                    sessionStorage.removeItem('sbp_ccdd');

                    _this.pt402ReqModel.siharaiHohoKbn = '1';
                    if (_this.sbpEmv3dsStatus == 'ok' && _this.sbpTdsAuthenticationId){
                        _this.pt402ReqModel.limitYear = sessionStorage['sbpLimitYear'];
                        _this.pt402ReqModel.limitMonth = sessionStorage['sbpLimitMonth'];
                        _this.pt402ReqModel.securityCode = sessionStorage['sbpSecurityCode'];
                        
                        sessionStorage.removeItem('sbpLimitYear');
                        sessionStorage.removeItem('sbpLimitMonth');
                        sessionStorage.removeItem('sbpSecurityCode');

                        _this.pt402ReqModel.tdsAuthenticationId = _this.sbpTdsAuthenticationId;
                        _this.update();
                    }

                    //SBペイメントの3DS認証要求NG後顧客決済情報の更新
                    if (_this.sbpEmv3dsStatus == 'ng'){                       
                        _this.listMessValid.push(_this.$i18n.t('pt402.messages.sbp3dsNgMsg'));
                        EventBus.$emit('message', {});
                        common.scrollTop();
                    }

                    _this.sbpEmv3dsStatus = '';
                }

                //gmo 3d
                if (_this.gmo2AuthAccessID){
                    _this.update();
                }

            }).catch(function(error) {
                common.errorAPI(error);
            });

            //Call method selectLink when selecting links on DataTable
            EventBus.$on("select-link", function(selectData) {
                _this.selectLink(selectData);
            });
            EventBus.$on('closed', () => {
                _this.isButtonCancel = false; 
            });
        },
        confirmUpdate: function(actFlg){
            var _this = this;
            _this.actionFlg = actFlg;

            switch (this.actionFlg) {
                case 1:
                    _this.msgConfirm = this.$i18n.t('pt402.messages.msg1')
                    break;
                case 2:
                    _this.msgConfirm = this.$i18n.t('pt402.messages.msg3')
                    break;
                default:
                    break;
            }
           
            _this.isModalShow = true;
        },
        /*
        * カード登録・更新
        */
        submit: function(){
            var _this = this;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT402_PART);
            // ASUKAオプションの場合
            if (_this.pt402DoInit.asukaOptionFlg == 1) {
                // カード情報チェック
                if(!this.cardCheck()) {
                    return false;
                }
                if ("0" == _this.scoring()) {
                    return false;
                }
            }

            _this.gmo2AuthAccessID = "";
            if (_this.pt402ReqModel.gmo2AuthAccessID){
                _this.pt402ReqModel.gmo2AuthAccessID = "";
            }
            if (_this.securityGmo3DFlg == 1){
                _this.pt402ReqModel.dispCardCd = _this.pt402ReqModel.cardNoDisp1 + _this.pt402ReqModel.cardNoDisp2 + _this.pt402ReqModel.cardNoDisp3 + _this.pt402ReqModel.cardNoDisp4;
                // 有効期限
                _this.pt402ReqModel.cardYy = _this.pt402ReqModel.limitYear;
                _this.pt402ReqModel.cardMm = _this.pt402ReqModel.limitMonth;
            }

            _this.sbpTdsAuthenticationId = null;
            if (_this.pt402ReqModel.tdsAuthenticationId) {
                _this.pt402ReqModel.sbp3DVerFlg = 0;
                _this.pt402ReqModel.tdsAuthenticationId = null;
            }

            _this.pt402ReqModel.siharaiHohoKbn = '1';
            if(_this.pt402ReqModel.kessaiCompKbn == 'JCS') {
                _this.saveJcs();
            } else {
                _this.$emit("event-loading", true);
                // 選択した決済情報、トークンURL、ショップIDを取得する
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT402 + _this.$UrlConstants.DO_AJAX,_this.pt402ReqModel).then(function(response) {              
                    _this.pt402DoInit.tokenUrl = response.data.tokenUrl;
                    _this.pt402DoInit.merchantId = response.data.merchantId;
                    _this.pt402DoInit.serviceId = response.data.serviceId;
                    _this.pt402DoInit.apiPass2 = response.data.apiPass2;
                    _this.pt402DoInit.tokenNinsyoCode = response.data.tokenNinsyoCode;
                    _this.pt402DoInit.serverUrl = response.data.serverUrl;
                    _this.pt402DoInit.shopId = response.data.shopId;

                    if (_this.pt402ReqModel.kessaiCompKbn == 'JCS') {
                        _this.saveJcs();
                    } else if (_this.pt402ReqModel.kessaiCompKbn == 'SBP') {
                        _this.doSbp();	
                    } else if (_this.pt402ReqModel.kessaiCompKbn == 'PAY') {
                        _this.doPayG();	
                    } else if (_this.pt402ReqModel.kessaiCompKbn == 'SPS') {
                        _this.doSps();
                    } else if (_this.pt402ReqModel.kessaiCompKbn == 'GMO') {
                        _this.doPurchase();
                    } else {
                        _this.update();
                    }
					_this.$emit("event-loading", false);
                }).catch(function(error) {
                    common.errorAPI(error);
                });
            }
        },
        /*
        * ASUKAシステム利用時ファンクション
        */
        scoring: function() {
            var _this = this;
            var r = '1';
            if (typeof aerosmith === 'undefined') {
                alert(_this.$i18n.t('sh060.messages.kessaiErr'));
                r = '0';
                return '0';
            } else {
                aerosmith.checkScore((reason) => {
                    console.log(reason);
                    switch (reason) {
                        case 'LRT':
                        case 'BIAT':
                        case 'MM':
                            return r;
                        default:
                            console.log('NG');
                            alert(_this.$i18n.t('sh060.messages.kessaiErr'));
                            r = '0';
                            return r;
                    }
                },
                (reason) => {
                    console.log(reason);
                    r = '0';
                    return r;
                });
            }
            return r;
        },
        /*
        * ASKUA準備完了チェック
        */
        reCheckAsukaReadyToScore: function() {
            var _this = this;

            if (_this.isAsukaReadyToScore || window.asukaAlready) {
                _this.isSubmitButton = true;
                _this.isAsukaReadyToScore = true;
            } else {
                window.setTimeout(function(){
                    _this.reCheckAsukaReadyToScore();
                }, 500);
            }
        },
        /*
        * GMOトークン取得
        */
        doPurchase : function() {
            var _this = this;
            var cardno,expire,securitycode,holdername,tokennumber;
            // 1枠入力の場合
            if (this.pt402DoInit.creditInpNumOption == 1) {
                cardno = this.pt402ReqModel.cardNoDisp;
                if (cardno) {
                    cardno = cardno.replaceAll(' ','');
                }
            // 4枠入力の場合
            } else {
                cardno = this.pt402ReqModel.cardNoDisp1 + this.pt402ReqModel.cardNoDisp2 + this.pt402ReqModel.cardNoDisp3 + this.pt402ReqModel.cardNoDisp4;
            }
            expire = this.pt402ReqModel.limitYear + this.pt402ReqModel.limitMonth;
            securitycode = this.pt402ReqModel.securityCode;
            holdername = this.pt402ReqModel.cardUserNm;
            if (this.pt402DoInit.cardNameOption == 1) {
                holdername = this.pt402ReqModel.cardNameNamae + ' ' + this.pt402ReqModel.cardNameMyouji;
            }

            // 取得したいトークンの数
            tokennumber = '2';
            securitycode = "";
            // トークン取得のURL
            var apiUrl = this.pt402DoInit.tokenUrl;
            var shopId = this.pt402DoInit.shopId;
            // カード情報チェック
            if(!this.cardCheck()) {
                return;
            }
            this.$loadScript(apiUrl) .then(() => {
                // eslint-disable-next-line
                Multipayment.init(shopId);
                // eslint-disable-next-line
                Multipayment.getToken(
                    {	cardno: cardno,
                        expire: expire,
                        securitycode: securitycode,
                        holdername: holdername,
                        tokennumber: tokennumber
                    },
                    function(response){
                        var errCode = response.resultCode;
                        if( errCode != '000' ){
                            if (errCode == '100') {
                                alert('カード番号は必須です。');
                            } else if (errCode == '101') {
                                alert('カード番号の値が不正です。');
                            } else if (errCode == '102') {
                                alert('カード番号の桁数に誤りがあります。');
                            } else if (errCode == '110') {
                                alert('有効期限は必須です。');
                            } else if (errCode == '111') {
                                alert('有効期限の値が不正です。');
                            } else if (errCode == '112') {
                                alert('有効期限の桁数に誤りがあります。');
                            } else if (errCode == '113') {
                                alert('有効期限の値が不正です。');
                            } else if (errCode == '121') {
                                alert('セキュリティコードの値が不正です。');
                            } else if (errCode == '122') {
                                alert('セキュリティコードの桁数に誤りがあります。');
                            } else if (errCode == '131') {
                                alert('名義人の値が不正です。');
                            } else if (errCode == '132') {
                                alert('名義人の桁数に誤りがあります。');
                            } else {
                                alert('内部処理エラーが発生しました。');
                            }
                        } else {
                            for (var token = 0; token < response.tokenObject.token.length; token++) {
                                if (token == 0) {
                                    _this.pt402ReqModel.token = response.tokenObject.token[token];
                                } else {
                                    _this.pt402ReqModel.token = _this.pt402ReqModel.token + "," + response.tokenObject.token[token];
                                }
                            }
                            _this.update();
                            return true;
                        }
                    }
                );
             })
            .catch(function(error) {
                console.log(error);
            });
        },
        /**
         * SBペイメントのトークン取得
         */
         doSbp: function() {
            const _this = this;
            const cardno = _this.pt402DoInit.creditInpNumOption == 1
                ? _this.pt402ReqModel.cardNoDisp
                : _this.pt402ReqModel.cardNoDisp1
                    + _this.pt402ReqModel.cardNoDisp2
                    + _this.pt402ReqModel.cardNoDisp3
                    + _this.pt402ReqModel.cardNoDisp4;
            const currentYear = new Date().getFullYear().toString();
            const expiration = 
                currentYear.substring(0, 2) + _this.pt402ReqModel.limitYear + _this.pt402ReqModel.limitMonth;

            const apiUrl = _this.pt402DoInit.tokenUrl;

            // カード情報チェック
            if(!this.cardCheck()) {
                return;
            }

            if (_this.securitySbp3DFlg == 0){
                _this.$loadScript(apiUrl).then(() => {
                    com_sbps_system.generateToken({
                        merchantId: _this.pt402DoInit.merchantId,
                        serviceId: _this.pt402DoInit.serviceId,
                        ccNumber: cardno ? cardno.replaceAll(' ','') : '',
                        ccExpiration: expiration,
                        securityCode: _this.pt402ReqModel.securityCode,
                    }, (response) => {
                        if (response.errorCode) {
                            const itemCode = response.errorCode.substring(2);
                            if (itemCode === '003') {
                                alert('クレジット番号に誤りがあります。');
                            } else if (itemCode === '004') {
                                alert('クレジット有効期限に誤りがあります。');
                            } else if (itemCode === '005') {
                                alert('セキュリティコードに誤りがあります。');
                            } else {
                                console.log(response.errorCode)
                                alert('内部処理エラーが発生しました。');
                            }
                            return false;
                        }
                        if (response.result === "OK") {
                            _this.pt402ReqModel.token = response.tokenResponse.token;
                            _this.pt402ReqModel.tokenKey = response.tokenResponse.tokenKey;

                            _this.update();
                        } else {
                            alert('トークン取得に失敗しました。');
                        }
                    });
                });
            }else{
                // 取得
                const tds2InfoTokenUrl = _this.pt402DoInit.tds2TokenUrl;
                _this.$loadScript(tds2InfoTokenUrl).then(() => {
                    com_sbps_system_tds2.generateToken({
                        merchantId: _this.pt402DoInit.merchantId,
                        serviceId: _this.pt402DoInit.serviceId,
                        billingLastName: (_this.pt402DoInit.cardNameOption == 1)?_this.pt402ReqModel.cardNameMyouji:'',
                        billingFirstName: (_this.pt402DoInit.cardNameOption == 1)?_this.pt402ReqModel.cardNameNamae:_this.pt402ReqModel.cardUserNm,
                        billingPostalCode: _this.stringNvl(_this.pt402DoInit.kokyakuInfo.KOKYAKU_ZIP, "").replace("-", ""),
                        billingCity: _this.stringNvl(_this.pt402DoInit.kokyakuInfo.KEN_NM, ""),
                        billingAddress1: _this.stringNvl(_this.pt402DoInit.kokyakuInfo.KOKYAKU_ADDR1, "").replace(_this.stringNvl(_this.pt402DoInit.kokyakuInfo.KEN_NM, ""), ""),
                        billingAddress2: _this.stringNvl(_this.pt402DoInit.kokyakuInfo.KOKYAKU_ADDR2, ""),
                        billingAddress3: _this.stringNvl(_this.pt402DoInit.kokyakuInfo.KOKYAKU_ADDR3, ""),
                        billingPhone: _this.stringNvl(_this.pt402DoInit.kokyakuInfo.KOKYAKU_TEL1, ""),
                        email: _this.stringNvl(_this.pt402DoInit.kokyakuInfo.KOKYAKU_MAIL1, "")
                    }, (tds2Response) => {
                        if (tds2Response.result === "NG"){
                            if (tds2Response.errorCode) {
                                const tds2ItemCode = tds2Response.errorCode.substring(2);
                                if (tds2ItemCode === '003') {
                                    //Last name of billing destination
                                    alert('カードの名義人に誤りがあります。');
                                } else if (tds2ItemCode === '004') {
                                    //First name of billing destination
                                    alert('カードの名義人に誤りがあります。');
                                } else if (tds2ItemCode === '005') {
                                    //Billing postal code
                                    alert('請求者の郵便番号に誤りがあります。');
                                } else if (tds2ItemCode === '006') {
                                    //Billing prefecture
                                    alert('請求者の住所に誤りがあります。');
                                } else if (tds2ItemCode === '007') {
                                    //Billing city/town
                                    alert('請求者の住所に誤りがあります。');
                                } else if (tds2ItemCode === '008') {
                                    //Billing street/number
                                    alert('請求者の住所に誤りがあります。');
                                } else if (tds2ItemCode === '009') {
                                    //Billing building name
                                    alert('請求者の住所に誤りがあります。');
                                } else if (tds2ItemCode === '010') {
                                    //Billing phone number
                                    alert('請求者の電話番号に誤りがあります。');
                                } else if (tds2ItemCode === '011') {
                                    //Contact phone number
                                    alert('請求者の電話番号に誤りがあります。');
                                } else if (tds2ItemCode === '012') {
                                    //Delivery postal code
                                    alert('お届先の郵便番号に誤りがあります。');
                                } else if (tds2ItemCode === '013') {
                                    //Delivery prefecture
                                    alert('お届先の住所に誤りがあります。');
                                } else if (tds2ItemCode === '014') {
                                    //Delivery city/town
                                    alert('お届先の住所に誤りがあります。');
                                } else if (tds2ItemCode === '015') {
                                    //Delivery street/number
                                    alert('お届先の住所に誤りがあります。');
                                } else if (tds2ItemCode === '016') {
                                    //Delivery building name
                                    alert('お届先の住所に誤りがあります。');
                                } else if (tds2ItemCode === '017') {
                                    //Email address
                                    alert('請求者のメールアドレスに誤りがあります。');
                                } else {
                                    alert('内部処理エラーが発生しました。');
                                }                           
                            }
                            return false;
                        } 

                        if (tds2Response.result === "OK") {
                            _this.pt402ReqModel.tds2InfoToken = tds2Response.tokenResponse.tds2infoToken;
                            _this.pt402ReqModel.tds2InfoTokenKey = tds2Response.tokenResponse.tds2infoTokenKey;

                            _this.$loadScript(apiUrl).then(() => {
                                com_sbps_system.generateToken({
                                    merchantId: _this.pt402DoInit.merchantId,
                                    serviceId: _this.pt402DoInit.serviceId,
                                    ccNumber: cardno ? cardno.replaceAll(' ','') : '',
                                    ccExpiration: expiration,
                                    securityCode: _this.pt402ReqModel.securityCode,
                                }, (response) => {
                                    if (response.errorCode) {
                                        const itemCode = response.errorCode.substring(2);
                                        if (itemCode === '003') {
                                            alert('クレジット番号に誤りがあります。');
                                        } else if (itemCode === '004') {
                                            alert('クレジット有効期限に誤りがあります。');
                                        } else if (itemCode === '005') {
                                            alert('セキュリティコードに誤りがあります。');
                                        } else {
                                            console.log(response.errorCode)
                                            alert('内部処理エラーが発生しました。');
                                        }
                                        return false;
                                    }
                                    if (response.result === "OK") {
                                        _this.pt402ReqModel.token = response.tokenResponse.token;
                                        _this.pt402ReqModel.tokenKey = response.tokenResponse.tokenKey;

                                        _this.update();
                                    } else {
                                        alert('トークン取得に失敗しました。');
                                    }
                                });
                            });

                            return true;
                        } else {
                            alert('カード利用者決済情報トークン取得に失敗しました。');
                            return false;
                        }
                    });
                });
            }
        },
        /**
         * SBペイメントの3DS認証要求NG後顧客決済情報の更新
         */
        updateForSbp3dsNg: function() {
            var _this = this;
			_this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT402_PART);
			_this.$emit("event-loading", true);
            // 決済情報更新
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT402 + _this.$UrlConstants.DO_UPDATE_FOR_SBP_3DS_NG,_this.pt402ReqModel).then(function(response) {
                _this.sbpEmv3dsStatus = '';
                _this.$emit("event-loading", false);
            }).catch(function(error) {
				_this.$emit("event-loading", false);
                    if(error != null && error != undefined){
                        _this.isModalShow = false;
                        if(error.response != null && error.response != undefined){
                            if(406 == error.response.status){
                                var resultValid = common.excuteValidationEcSite(error, _this.PT402_PART);
                                if(resultValid){
                                    _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                    _this.listMessValid = resultValid.msgList;
                                    _this.mapMessValid = resultValid.mapMsg;
                                }
                            }else{
                                common.errorAPI(error);
                            }
                        }
                    }
				common.scrollTop();
            }).finally(function() {
                _this.cardNoDelete();
            })
        },

        /*
        *ペイジェントのトークン取得
        */
        doPayG: function(){
            var _this = this;
            var tokenUrl = this.pt402DoInit.tokenUrl;
            // マーチャントID
            var machantoId = this.pt402DoInit.confText1;
            // トークン生成鍵
            var tokunSeiseikagi = this.pt402DoInit.apiPass2;
            var cardno = "";
            // カード入力項目が1枠の場合
            if (this.pt402DoInit.creditInpNumOption == 1) {
                // カード番号
                cardno = this.pt402ReqModel.cardNoDisp;
                cardno = cardno.replaceAll(' ','');
            } else {
                // カード番号
                cardno = this.pt402ReqModel.cardNoDisp1 + this.pt402ReqModel.cardNoDisp2 + this.pt402ReqModel.cardNoDisp3 + this.pt402ReqModel.cardNoDisp4;
            }
            // 名義人
            var holdername = this.pt402ReqModel.cardUserNm;
            if (this.pt402DoInit.cardNameOption == 1) {
                holdername = this.pt402ReqModel.cardNameNamae + ' ' + this.pt402ReqModel.cardNameMyouji;
            }

            this.$loadScript(tokenUrl).then(() => {
                // eslint-disable-next-line
                var paygentToken = new PaygentToken();
                paygentToken.createToken(
                    machantoId, //マーチャントID
                    tokunSeiseikagi, //トークン生成鍵
                    {
                    card_number:cardno, //クレジットカード番号
                    expire_year:this.pt402ReqModel.limitYear, //有効期限-YY
                    expire_month: this.pt402ReqModel.limitMonth, //有効期限-MM
                    cvc: this.pt402ReqModel.securityCode, //セキュリティーコード
                    name:holdername //カード名義
                    },function(response){
                        //正常終了
                        if(response.result == '0000'){
                            //トークン
                            _this.pt402ReqModel.token = response.tokenizedCardObject.token;
                            _this.pt402ReqModel.securityCode = "";
                            _this.update();
                        //エラー
                        }else{
                            if(response.result == '1100'){
                                alert('マーチャントID - 必須エラー');
                            }else if(response.result == '1200'){
                                alert('トークン生成公開鍵 - 必須エラー');
                            }else if(response.result == '1200'){
                                alert('トークン生成公開鍵 - 必須エラー');
                            }else if(response.result == '1201'){
                                alert('トークン生成公開鍵 - 不正エラー');
                            }else if(response.result == '1300'){
                                alert('カード番号 - 必須チェックエラー');
                            }else if(response.result == '1301'){
                                alert('カード番号 - 書式チェックエラー');
                            }else if(response.result == '1400'){
                                alert('有効期限(年) - 必須チェックエラー');
                            }else if(response.result == '1401'){
                                alert('有効期限(年) - 書式チェックエラー');
                            }else if(response.result == '1500'){
                                alert('有効期限(月) - 必須チェックエラー');
                            }else if(response.result == '1501'){
                                alert('有効期限(月) - 書式チェックエラー');
                            }else if(response.result == '1502'){
                                alert('有効期限(年月)が不正です。');
                            }else if(response.result == '1600'){
                                alert('セキュリティコード - 書式チェックエラー');
                            }else if(response.result == '1601'){
                                alert('セキュリティコード - 必須エラー（セキュリティコードトークンの場合）');
                            }else if(response.result == '1700'){
                                alert('カード名義 - 書式チェックエラー');
                            }else if(response.result == '7000'){
                                alert('非対応のブラウザです。');
                            }else if(response.result == '7001'){
                                alert('ペイジェントとの通信に失敗しました。');
                            }else if(response.result == '8000'){
                                alert('システムメンテナンス中です。');
                            }else if(response.result == '9000'){
                                alert('ペイジェント決済システム内部エラー');
                            }
                        }
                    }
                );
            })
            .catch(function(error) {
                console.log(error);
            });
        },
        /**
         * ソニーペイメントのトークン取得
         */
         doSps: async function() {
            const _this = this;
            _this.pt402ReqModel.spsResultId = null;

            var cardnoTmp = "";
            // カード入力項目が1枠の場合
            if (_this.pt402DoInit.creditInpNumOption == 1) {
                // カード番号
                cardnoTmp = _this.pt402ReqModel.cardNoDisp;
                if (cardnoTmp !== undefined && cardnoTmp !== null && cardnoTmp !== '') {
                    cardnoTmp = cardnoTmp.replaceAll(' ','');
                }
            } else {
                // カード番号
                if (_this.pt402ReqModel.cardNoDisp1 !== undefined && _this.pt402ReqModel.cardNoDisp1 !== null && _this.pt402ReqModel.cardNoDisp1 !== '') {
                    cardnoTmp = cardnoTmp + _this.pt402ReqModel.cardNoDisp1;
                }
                if (_this.pt402ReqModel.cardNoDisp2 !== undefined && _this.pt402ReqModel.cardNoDisp2 !== null && _this.pt402ReqModel.cardNoDisp2 !== '') {
                    cardnoTmp = cardnoTmp + _this.pt402ReqModel.cardNoDisp2;
                }
                if (_this.pt402ReqModel.cardNoDisp3 !== undefined && _this.pt402ReqModel.cardNoDisp3 !== null && _this.pt402ReqModel.cardNoDisp3 !== '') {
                    cardnoTmp = cardnoTmp + _this.pt402ReqModel.cardNoDisp3;
                }
                if (_this.pt402ReqModel.cardNoDisp4 !== undefined && _this.pt402ReqModel.cardNoDisp4 !== null && _this.pt402ReqModel.cardNoDisp4 !== '') {
                    cardnoTmp = cardnoTmp + _this.pt402ReqModel.cardNoDisp4;
                }
            }
            // カード有効期限
            var expireTmp = "";
            if (_this.pt402ReqModel.limitMonth != undefined && _this.pt402ReqModel.limitMonth !== null && _this.pt402ReqModel.limitMonth !== '') {
                expireTmp = expireTmp + _this.pt402ReqModel.limitMonth;
            }
            if (_this.pt402ReqModel.limitYear != undefined && _this.pt402ReqModel.limitYear !== null && _this.pt402ReqModel.limitYear !== '') {
                expireTmp = expireTmp + _this.pt402ReqModel.limitYear;
            }

            if (_this.pt402ReqModel.siharaiHohoKbn == '1') {
                // バリデーション
                _this.listMessValid = [];
                let isError = false;
                if(cardnoTmp == null || cardnoTmp == undefined || cardnoTmp == ''){
                    // カード番号を入力してください。
                    _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoMust'));
                    isError = true;
                } else {
                    if (cardnoTmp.length < 14 || cardnoTmp.length > 16) {
                        // カード番号の入力値に誤りがあります。14桁以上16桁以内の数字で入力してください。
                        _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoInputErr'));
                        isError = true;
                    }
                }
                if(expireTmp == null || expireTmp == undefined || expireTmp == ''){
                    // カード有効期限を入力してください。
                    _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateMust'));
                    isError = true;
                } else {
                    if (expireTmp.length < 4 ) {
                        // カード有効期限の入力値に誤りがあります。半角数値（「月/年」）で入力してください。
                        _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateInputErr'));
                        isError = true;
                    }
                }
                // 名義人必須チェック
                if (_this.pt402DoInit.cardNameOption == 1) {
                    if(!_this.pt402ReqModel.cardNameMyouji || !_this.pt402ReqModel.cardNameNamae) {
                        _this.listMessValid.push(_this.$i18n.t('sh060.labels.holdernameMustErr'));
                        isError = true;
                    }
                } else {
                    if(!_this.pt402ReqModel.cardUserNm){
                        _this.listMessValid.push(_this.$i18n.t('sh060.labels.holdernameMustErr'));
                        isError = true;
                    }
                }
                if (_this.pt402DoInit.securityCodeUseFlg) {
                    if(!_this.pt402ReqModel.securityCode) {
                        // セキュリティコードを入力してください。
                        _this.listMessValid.push(_this.$i18n.t('sh060.messages.secMust'));
                        isError = true;
                    }
                }

                if (isError) {
                    _this.$emit("event-loading", false);
                    EventBus.$emit('message', {});
                    common.scrollTop();
                    return true;
                }
            }
            
            // SPSトークン取得
            const loadScriptSps = (url) => {
                return new Promise((resolve, reject) => {
                    if (document.querySelector('script[src="' + url + '"]')) {
                        return resolve();
                    }

                    const script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.async = true;
                    script.src = url;
                    script.setAttribute('callBackFunc', 'setToken');
                    script.setAttribute('class', 'spsvToken');
        
                    script.addEventListener('load', resolve);
                    script.addEventListener('error', reject);
                    script.addEventListener('abort', reject);
        
                    document.head.appendChild(script);
                });
            };

            const cardno = _this.pt402DoInit.creditInpNumOption == 1
                ? _this.pt402ReqModel.cardNoDisp
                : _this.pt402ReqModel.cardNoDisp1
                    + _this.pt402ReqModel.cardNoDisp2
                    + _this.pt402ReqModel.cardNoDisp3
                    + _this.pt402ReqModel.cardNoDisp4;
            const expirationYear = _this.pt402ReqModel.limitYear;
            const expirationMonth =  _this.pt402ReqModel.limitMonth;

            const apiUrl = `${_this.pt402DoInit.tokenUrl}?k_TokenNinsyoCode=${_this.pt402DoInit.tokenNinsyoCode}`;
            await loadScriptSps(apiUrl);

            SpsvApi.spsvCreateToken(
                cardno ? cardno.replaceAll(' ','') : '', // 第１引数：カード番号
                expirationYear, // 第２引数：有効期限（年）
                expirationMonth, // 第３引数：有効期限（年）
                _this.pt402ReqModel.securityCode, // 第４引数：セキュリティコード
                '', // 第６引数：生年月日（日）
                '', // 第７引数：電話番号
                '', // 第８引数：カナ氏名（姓）
                '', // 第９引数：カナ氏名（名）
            );

            // タイムアウト
            const timeId = setTimeout(() => {
                window.removeEventListener('message', handleMessage);
                alert('トークン取得に失敗しました。');
                return false;
            }, spsvGetParam('timeOut'));

            // メッセージイベントからトークンを取得する
            const handleMessage = (event) => {
                if (event.origin !== null && event.origin !== '' && event.origin !== undefined && event.origin != 'null') {
                    if (event.origin !== spsvGetParam('spsvOrigin')) {
                        if (event.origin.indexOf(spsvGetParam('spsvOrigin')) == -1) {
                            return;
                        }
                    }
                }
                try {
                    const message = JSON.parse(event.data);
                    if (
                        message.spsvOrigin !== null &&
                        message.spsvOrigin !== '' &&
                        message.spsvOrigin !== undefined &&
                        message.spsvOrigin != 'null'
                    ) {
                        if (message.spsvOrigin !== spsvGetParam('spsvOrigin')) {
                            return;
                        }
                        if (typeof message.tokenKbn == 'undefined' && message.token && message.token !== 'maked') {
                            clearTimeout(timeId);
                            window.removeEventListener('message', handleMessage);
                            _this.pt402ReqModel.token = message.token;
                            _this.updateForSps();
                            return true;
                        }
                    }
                } catch (e) {
                    console.log(e);
                }
            }
            window.addEventListener('message', handleMessage);
         },
         updateForSps: function() {
            var _this = this;
			_this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT402_PART);
			_this.$emit("event-loading", true);
            _this.pt402ReqModel.pageNo = 86;
            // 決済情報更新
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT402 + _this.$UrlConstants.DO_UPDATE_FOR_SPS,_this.pt402ReqModel).then(function(response) {
                if (response.data.spsResultId && (response.data.operateId == '4MemAdd' || response.data.operateId == '4MemChg')) {
                    var PageNo = "81";
                    _this.pt402ReqModel.securityCode = "";
                    // トースト表示
                    toastr.success(_this.$i18n.t('pt402.messages.msg2'));
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: PageNo}});
                    _this.$emit("event-loading", false);
                } else {
                    _this.doSps3DS(response.data);
                    return;
                }
            }).catch(function(error) {
				_this.$emit("event-loading", false);
                    if(error != null && error != undefined){
                        _this.isModalShow = false;
                        if(error.response != null && error.response != undefined){
                            if(406 == error.response.status){
                                var resultValid = common.excuteValidationEcSite(error, _this.PT402_PART);
                                if(resultValid){
                                    _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                    _this.listMessValid = resultValid.msgList;
                                    _this.mapMessValid = resultValid.mapMsg;
                                }
                            }else{
                                common.errorAPI(error);
                            }
                        }
                    }
				common.scrollTop();
            }).finally(function() {
                _this.cardNoDelete();
            })
        },
         /**
         * ソニーペイメント3DS呼び出し
         */
         doSps3DS: function(response) {
            sessionStorage.setItem('orderCdTypical', this.pt402ReqModel.orderCdTypical);
            sessionStorage.setItem('orderCd', this.pt402ReqModel.orderCd);
            sessionStorage.setItem('teikiFlg', this.pt402ReqModel.teikiFlg);
            sessionStorage.setItem('teikiNo', this.pt402ReqModel.teikiNo);
            sessionStorage.setItem('backPageNo', this.pt402ReqModel.backPageNo);
           
            this.sps3DSAuthori.merchantId = response.merchantId;
            this.sps3DSAuthori.encValue = response.encValue;
            this.$nextTick(() => this.$refs.formSps3D.submit()); 
        },
        /*
        * カード番号を削除
        */
        cardNoDelete: function(){
            var _this = this;
            // カード番号
            _this.pt402ReqModel.cardNoDisp = "";
            _this.pt402ReqModel.cardNoDisp1 = "";
            _this.pt402ReqModel.cardNoDisp2 = "";
            _this.pt402ReqModel.cardNoDisp3 = "";
            _this.pt402ReqModel.cardNoDisp4 = "";
            // セキュリティコード
            _this.pt402ReqModel.securityCode = "";
            // 名義人
            _this.pt402ReqModel.cardName = "";
            // 有効期限
            _this.pt402ReqModel.limitYear = "";
            _this.pt402ReqModel.limitMonth = "";

            // 名義人
            _this.pt402ReqModel.cardNameMyouji = "";
            _this.pt402ReqModel.cardNameNamae = "";
            _this.pt402ReqModel.cardUserNm = "";

            if(_this.pt402ReqModel.kessaiCompKbn !== "JCS" && _this.pt402ReqModel.kessaiCompKbn !== "SGP" && _this.pt402ReqModel.kessaiCompKbn !== "GMO" && _this.pt402ReqModel.kessaiCompKbn !== "PAY") {
                _this.pt402ReqModel.cardPayCnt = "";
            }
            
        },
        /*
        * カード登録・更新処理
        */
        update: function() {
            var _this = this;
			_this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT402_PART);
			_this.$emit("event-loading", true);
            _this.cardNoDelete();
            _this.pt402ReqModel.siharaiHohoKbn = "1";

            if (_this.securitySbp3DFlg == 1){
                _this.pt402ReqModel.sbp3DVerFlg = _this.securitySbp3DFlg;
                _this.pt402ReqModel.sbp3DVerBackUrl = window.location.origin + window.location.pathname;
            }else{
                _this.sbpTdsAuthenticationId = '';
                _this.pt402ReqModel.sbp3DVerFlg = 0;
                _this.pt402ReqModel.sbp3DVerBackUrl = "";
            }

            if (_this.securityGmo3DFlg == 1){
                _this.pt402ReqModel.gmo3DVer2Flg = _this.securityGmo3DFlg; //GMO 3D 2.0 セキュア利用フラグ
                _this.pt402ReqModel.gmo3DVer2BackUrl = window.location.origin + window.location.pathname + "?pageNo=" +  _this.currPageNo;
                _this.pt402ReqModel.gmo2AuthAccessID = _this.gmo2AuthAccessID;
                if (_this.gmo2AuthAccessID){
                    _this.pt402ReqModel.gmoAccessPass = _this.gmoAccess;
                    _this.pt402ReqModel.gmoOrderId = _this.gmoOrderCd;
                    _this.pt402ReqModel.gmoCustCd = _this.gmoCustCd;
                }else{
                    _this.pt402ReqModel.gmoAccessPass = '';
                    _this.pt402ReqModel.gmoOrderId = '';
                    _this.pt402ReqModel.gmoCustCd = '';
                }
                if (_this.gmo2AuthAccessID){
                    if (!_this.gmoAccess){
                        _this.$emit("event-loading", false);
                        return;
                    }
                }
            }

            // 決済情報更新
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT402 + _this.$UrlConstants.DO_UPDATE,_this.pt402ReqModel).then(function(response) {
                _this.pt402ReqModel.securityCode = "";
                if(response.data.status == "OK"){
                    if (_this.securitySbp3DFlg == 1){
                        let apiRequestId = response.data.response.apiRequestId;
                        if (apiRequestId == 'TA02-00101-101'){
                            let redirectUrl = '';
                            if (response.data.response.redirectUrl){
                                redirectUrl = response.data.response.redirectUrl;
                            }

                            if (response.data.response.apiResult == "OK"){
                                sessionStorage['sbpTdsAuthenticationId'] = response.data.response.tdsAuthenticationId;
                                sessionStorage['sbpLimitYear'] = _this.pt402ReqModel.limitYear;
                                sessionStorage['sbpLimitMonth'] = _this.pt402ReqModel.limitMonth;
                                sessionStorage['sbpSecurityCode'] = _this.pt402ReqModel.securityCode;
                                sessionStorage['sbp_ccdd'] = response.data.response.sbp_cust_cd;

                                if (_this.pt402ReqModel.orderCdTypical){
                                    sessionStorage.setItem('orderCdTypical', _this.pt402ReqModel.orderCdTypical);
                                }
                                if (_this.pt402ReqModel.orderCd){
                                    sessionStorage.setItem('orderCd', _this.pt402ReqModel.orderCd);
                                }
                                if (_this.pt402ReqModel.teikiFlg){
                                    sessionStorage.setItem('teikiFlg', _this.pt402ReqModel.teikiFlg);
                                }
                                if (_this.pt402ReqModel.teikiNo){
                                    sessionStorage.setItem('teikiNo', _this.pt402ReqModel.teikiNo);
                                }
                                if (_this.pt402ReqModel.backPageNo){
                                    sessionStorage.setItem('backPageNo', _this.pt402ReqModel.backPageNo);
                                }

                            }else{
                                sessionStorage['tdsAuthenticationId'] = '';
                                console.log(response.data.response.apiErrCode);
                            }
                            if (redirectUrl){
                                window.location.href = redirectUrl;
                            }
                            _this.$emit("event-loading", false);
                             return; 
                        }

                        _this.securitySbp3DFlg = 0;
                        _this.sbpTdsAuthenticationId = '';
                        _this.pt402ReqModel.sbp3DVerFlg = 0;
                        _this.pt402ReqModel.sbp3DVerBackUrl = "";
                    }

                    if (_this.securityGmo3DFlg == 1){
                        if (response.data.response){
                            _this.resGmoVer2ACS = response.data.response.resGmoVer2ACS;
                            _this.resGmoVer2RedirectUrl = response.data.response.resGmoVer2RedirectUrl;
                        }
                        if (_this.resGmoVer2ACS == '2'){
                            sessionStorage['gmoAccess'] = response.data.response.gmoAccess;
                            sessionStorage['gmoCustCd'] = response.data.response.gmoCustCd;
                            sessionStorage['gmoOrderCd'] = response.data.response.gmoOrderCd;
                            
                            if (_this.pt402ReqModel.orderCdTypical){
                                sessionStorage.setItem('orderCdTypical', _this.pt402ReqModel.orderCdTypical);
                            }
                            if (_this.pt402ReqModel.orderCd){
                                sessionStorage.setItem('orderCd', _this.pt402ReqModel.orderCd);
                            }
                            if (_this.pt402ReqModel.teikiFlg){
                                sessionStorage.setItem('teikiFlg', _this.pt402ReqModel.teikiFlg);
                            }
                            if (_this.pt402ReqModel.teikiNo){
                                sessionStorage.setItem('teikiNo', _this.pt402ReqModel.teikiNo);
                            }
                            if (_this.pt402ReqModel.backPageNo){
                                sessionStorage.setItem('backPageNo', _this.pt402ReqModel.backPageNo);
                            }
                            window.location.href = _this.resGmoVer2RedirectUrl;
                            _this.$emit("event-loading", false);
                            return;
                        }
                    }

                    var PageNo = "";
                    var teiki_no;
                    var backPageNo;
                    // トースト表示
                    toastr.success(_this.$i18n.t('pt402.messages.msg2'));
                    if (_this.pt402ReqModel.backPageNo == "82") {
                        teiki_no = _this.pt402ReqModel.teikiNo;
                        PageNo = "82";
                        backPageNo = "89";
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: PageNo},params: {teikiNo: teiki_no,backPageNo: backPageNo,teikiFlg: '1'}});
                    } else if(_this.spsResultId) {
                        PageNo = "81";
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: PageNo}});
                    } else {
                        if (_this.securityGmo3DFlg == 1){
                            _this.gmo2AuthAccessID = '';
                            _this.pt402ReqModel.gmoAccessPass = '';
                            _this.pt402ReqModel.gmoOrderId = '';
                            _this.pt402ReqModel.gmoCustCd = '';
                        }
                        _this.init();
                    }
                }
				_this.$emit("event-loading", false);
            }).catch(function(error) {
				_this.$emit("event-loading", false);
                    if(error != null && error != undefined){
                        _this.isModalShow = false;
                        if(error.response != null && error.response != undefined){
                            if(406 == error.response.status){
                                var resultValid = common.excuteValidationEcSite(error, _this.PT402_PART);
                                if(resultValid){
                                    _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                    _this.listMessValid = resultValid.msgList;
                                    _this.mapMessValid = resultValid.mapMsg;
                                }
                            }else{
                                common.errorAPI(error);
                            }
                        }
                    }
				common.scrollTop();
            });
        },

        /*
        * カード削除処理
        */
        doDeleteCard: function(){
            var _this = this;
			_this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT402_PART);
			_this.$emit("event-loading", true);
            _this.pt402ReqModel.siharaiHohoKbn = "1";

            // 決済情報削除
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT402 + _this.$UrlConstants.DO_DELETE,_this.pt402ReqModel).then(function(response) {
                if(response.data.status == "OK"){
                    // トースト表示
                    toastr.success(_this.$i18n.t('pt402.messages.msg4'));
                    _this.init();
                }
				_this.$emit("event-loading", false);
            }).catch(function(error) {
				_this.$emit("event-loading", false);
                    if(error != null && error != undefined){
                        _this.isModalShow = false;
                        if(error.response != null && error.response != undefined){
                            if(406 == error.response.status){
                                var resultValid = common.excuteValidationEcSite(error, _this.PT402_PART);
                                if(resultValid){
                                    _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                    _this.listMessValid = resultValid.msgList;
                                    _this.mapMessValid = resultValid.mapMsg;
                                }
                            }else{
                                common.errorAPI(error);
                            }
                        }
                    }
				common.scrollTop();
            });
        },

		backPage: function(){
			var _this = this;
			_this.listMessValid = [];
            _this.mapMessValid = [];
            var PageNo = "81";
            var customUrl = _this.pt402DoInit.myPage;
            var teiki_no;
            var backPageNo;
            if (_this.pt402ReqModel.backPageNo == "82") {
                teiki_no = _this.pt402ReqModel.teikiNo;
                PageNo = "82";
                customUrl = _this.pt402DoInit.teikiListPage;
                backPageNo = "89";
            }
            
            common.clearMessageEcSite(_this.listIdErr, _this.PT402_PART);
            const parameter = _this.generateLinkParams(PageNo, customUrl, {}, {teikiNo: teiki_no,backPageNo: backPageNo,teikiFlg: '1'});
            _this.$router.push(parameter);
        },
        // ルーターリンクパラメータ設定
        generateLinkParams(pageNo, customUrl, additionalQuery = {}, additionalParams = {}) {
            return common.routerLinkParams(pageNo, customUrl, additionalQuery, additionalParams);
        },
        /*
        *  execute update or delete or insert
        */
        doAction: function(){
            var _this = this;
            switch (this.actionFlg) {
                case 1:
                    this.submit();
                    break;
                case 2:
                    this.doDeleteCard();
                    break;
                default:
                    break;
            }
            // Hide alert confirm
            _this.isModalShow = false;
            _this.actionFlg = 0;
            _this.isButtonCancel = true;
        },
        /*
        * ラジオボタン選択処理
        */
        selectSiharaiHoho: function(value) {
            var _this = this;
            if (value == '1') {
                _this.showFlg = false;
            } else if(value == '2') {
                _this.showFlg = true;
            }
        },

        saveJcs() {
            let _this = this;

            _this.listMessValid = [];
            if(!_this.pan) {
                // カード番号を入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoMust'));
            } else if (_this.pan.length < 14 ) {
                // カード番号の入力値に誤りがあります。14桁以上16桁以内の数字で入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoInputErr'));
            }
            if(!_this.expiryDate) {
                // カード有効期限を入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateMust'));
            } else if (_this.expiryDate.length < 4 ) {
                // カード有効期限の入力値に誤りがあります。半角数値（「月/年」）で入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateInputErr'));
            }
            // 名義人必須チェック
           

            if (_this.pt402DoInit.cardNameOption == 1) {
                if(!_this.pt402ReqModel.cardNameMyouji || !_this.pt402ReqModel.cardNameNamae) {
                    _this.listMessValid.push(_this.$i18n.t('sh060.labels.holdernameMustErr'));
                }
            } else {
                if(!_this.pt402ReqModel.cardUserNm){
                    _this.listMessValid.push(_this.$i18n.t('sh060.labels.holdernameMustErr'));
                }
            }
            if(_this.pt402DoInit.securityCodeUseFlg) {
                if(!_this.pt402ReqModel.securityCode) {
                    // セキュリティコードを入力してください。
                    _this.listMessValid.push(_this.$i18n.t('sh060.messages.secMust'));
                }
            }

            if(_this.listMessValid.length > 0) {
                EventBus.$emit('message', {});
                common.scrollTop();
                return;
            }

            _this.$refs.form[0].submit();
            _this.cardNoDelete();

            _this.$emit("event-loading", true);

            var startTime = new Date().getTime();
            _this.timer = setInterval(function() {
                if(new Date().getTime() - startTime > 15 * 1000) {
                    clearInterval(_this.timer);
                    _this.doConfirm('');
                }
                let resp = _this.$refs['dummyframe'].contentWindow.document.body.innerHTML;
                if(resp && resp.indexOf('errCode') !== -1) {
                    clearInterval(_this.timer);
                    _this.doConfirm(resp);
                }
            }, 1000);
        },

        doConfirm(resp) {
            let _this = this;
            if (resp.indexOf('OLM-IT00000000') !== -1) {
                _this.pt402ReqModel.newDbKey = _this.pt402DoInit.newDbKey;
                _this.update();
            } else { 
                _this.$emit("event-loading", false);
                _this.listMessValid = [];
                // クレジットカード登録処理に失敗しました。申し訳ございませんが、しばらく時間をあけて定期購入画面からやり直してください。
                _this.listMessValid.push(_this.$i18n.t('pt431.messages.kessaiErr'));
                EventBus.$emit('message', {});
                common.scrollTop();
            }
        },
        // フォーカスが外れた時、月を前０をセットする
        onBlur: function() {
            var limMonth = this.pt402ReqModel.limitMonth;
            this.pt402ReqModel.limitMonth = limMonth.padStart(2, "0");
        },
        // クレジット番号の4桁区切りでスペースを入れる処理
        onCredit: function() {
            var cardNo = this.pt402ReqModel.cardNoDisp;
            const regexp = /^(\d{1,4})?(\d{1,4})?(\d{1,4})?(\d{1,4})?$/;
            const digits = cardNo.replace(/[^0-9]/g, '');
            this.pt402ReqModel.cardNoDisp = [...regexp.exec(digits)].slice(1).filter(e => e).join(' ');
        },
        /*
        * カード情報チェック
        */
       cardCheck: function() {
            var _this = this;
            var cardNo = "";
            var cardYear = "";
            var cardMonth = "";
            var securitycode = "";

            cardYear = _this.pt402ReqModel.limitYear;
            cardMonth = _this.pt402ReqModel.limitMonth;
            securitycode = _this.pt402ReqModel.securityCode;

            if (_this.pt402DoInit.creditInpNumOption == 1) {
                cardNo = _this.pt402ReqModel.cardNoDisp;
                if (cardNo != undefined) {
                    cardNo = cardNo.replaceAll(' ','');
                }
            } else {
                cardNo = _this.pt402ReqModel.cardNoDisp1 + _this.pt402ReqModel.cardNoDisp2 + _this.pt402ReqModel.cardNoDisp3 + _this.pt402ReqModel.cardNoDisp4;
            }
            // カード番号必須チェック
            if (cardNo == null || cardNo == undefined || cardNo == '' || Number.isNaN(cardNo) || cardNo.length < 14 || cardNo.length > 16) {
                // カード番号を入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoMust'));
            }
            // 有効期限必須チェック
            if ((cardYear == null || cardYear == undefined) || (cardMonth == null || cardMonth == undefined)) {
                // 有効期限を入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateMust'));
            }
            // 名義人必須チェック
            if (_this.pt402DoInit.cardNameOption == 1) {
                if(!_this.pt402ReqModel.cardNameMyouji || !_this.pt402ReqModel.cardNameNamae) {
                    _this.listMessValid.push(_this.$i18n.t('sh060.labels.holdernameMustErr'));
                }
            } else {
                if(!_this.pt402ReqModel.cardUserNm){
                    _this.listMessValid.push(_this.$i18n.t('sh060.labels.holdernameMustErr'));
                }
            }
            // セキュリティコード必須チェック
            if (_this.pt402DoInit.securityCodeUseFlg) {
                if (!securitycode) {
                    // セキュリティコードを入力してください。
                    this.listMessValid.push(_this.$i18n.t('sh060.messages.secMust'));
                }
            }

            // エラーがある場合
            if(_this.listMessValid.length > 0) {
                EventBus.$emit('message', {});
                common.scrollTop();
                return false;
            }
            return true;
       },

        /*
         * Function stringNvl
        */
        stringNvl: function(strVal, defVal){
            if(strVal==undefined){
                return defVal;
            }else{
                return strVal;
            }
        },
    },
    /*
    * destroy eventbus of page before close page
    */
    beforeDestroy: function() {
        clearInterval(this.timer);
        //close select-link eventbus
        EventBus.$off("select-link");
    },
    /*
    * Excute code after an instance is created
    */
    created: function(){
        var _this = this;
        var queryData = _this.$route.query;
        if(Object.keys(queryData).length > 0){
            if (queryData.spsResultId) {
                _this.spsResultId = queryData.spsResultId;
                _this.operateId = queryData.operateId;
            }
            if (_this.$route.query.pageNo){
                _this.currPageNo = _this.$route.query.pageNo;
            }else{
                 _this.currPageNo = 86;
            }
            //sbp 3d back
            if (_this.$route.query.sbpEmv3dsStatus) {
                _this.sbpEmv3dsStatus = _this.$route.query.sbpEmv3dsStatus;

                if (sessionStorage['orderCdTypical']){
                    _this.pt402ReqModel.orderCdTypical = sessionStorage['orderCdTypical'];
                }
                if (sessionStorage['orderCd']){
                    _this.pt402ReqModel.orderCd = sessionStorage['orderCd'];
                }
                if (sessionStorage['teikiFlg']){
                    _this.pt402ReqModel.teikiFlg = sessionStorage['teikiFlg'];
                }
                if (sessionStorage['teikiNo']){
                    _this.pt402ReqModel.teikiNo = sessionStorage['teikiNo'];
                }
                if (sessionStorage['backPageNo']){
                    _this.pt402ReqModel.backPageNo = sessionStorage['backPageNo'];
                } 
                sessionStorage.removeItem('orderCdTypical');
                sessionStorage.removeItem('orderCd');
                sessionStorage.removeItem('teikiFlg');
                sessionStorage.removeItem('teikiNo');
                sessionStorage.removeItem('backPageNo');

                if (_this.sbpEmv3dsStatus == 'ok'){
                    _this.sbpTdsAuthenticationId = sessionStorage['sbpTdsAuthenticationId'];
                    sessionStorage.removeItem('sbpTdsAuthenticationId');
                }else{
                    _this.pt402ReqModel.limitYear = sessionStorage['sbpLimitYear'];
                    _this.pt402ReqModel.limitMonth = sessionStorage['sbpLimitMonth'];
                    _this.pt402ReqModel.securityCode = sessionStorage['sbpSecurityCode'];
                    
                    _this.sbpTdsAuthenticationId = '';
                    sessionStorage.removeItem('sbpTdsAuthenticationId');
                    sessionStorage.removeItem('sbpLimitYear');
                    sessionStorage.removeItem('sbpLimitMonth');
                    sessionStorage.removeItem('sbpSecurityCode');
                }
            } else if (_this.$route.query.AccessID){
                _this.gmo2AuthAccessID = _this.$route.query.AccessID;

                _this.gmoAccess = sessionStorage['gmoAccess'];
                _this.gmoCustCd = sessionStorage['gmoCustCd'];
                _this.gmoOrderCd = sessionStorage['gmoOrderCd'];
                sessionStorage.removeItem('gmoAccess');
                sessionStorage.removeItem('gmoCustCd');
                sessionStorage.removeItem('gmoOrderCd');

                if (sessionStorage['orderCdTypical']){
                    _this.pt402ReqModel.orderCdTypical = sessionStorage['orderCdTypical'];
                }
                if (sessionStorage['orderCd']){
                    _this.pt402ReqModel.orderCd = sessionStorage['orderCd'];
                }
                if (sessionStorage['teikiFlg']){
                    _this.pt402ReqModel.teikiFlg = sessionStorage['teikiFlg'];
                }
                if (sessionStorage['teikiNo']){
                    _this.pt402ReqModel.teikiNo = sessionStorage['teikiNo'];
                }
                if (sessionStorage['backPageNo']){
                    _this.pt402ReqModel.backPageNo = sessionStorage['backPageNo'];
                } 
                sessionStorage.removeItem('orderCdTypical');
                sessionStorage.removeItem('orderCd');
                sessionStorage.removeItem('teikiFlg');
                sessionStorage.removeItem('teikiNo');
                sessionStorage.removeItem('backPageNo');
            }
        }
        var paramData = _this.$route.params;
        if(Object.keys(paramData).length > 0){
            _this.pt402ReqModel.orderCdTypical = paramData.orderNo;
            _this.pt402ReqModel.orderCd = paramData.orderNo;
            _this.pt402ReqModel.teikiFlg = paramData.teikiFlg;
            _this.pt402ReqModel.teikiNo = paramData.teikiNo;
            _this.pt402ReqModel.backPageNo = paramData.backPageNo;
        }
    },

    computed: {
        pan: function () {
            var cardNo;
            if (this.pt402DoInit.creditInpNumOption == 1) {
                cardNo = this.pt402ReqModel.cardNoDisp;
                if (cardNo != undefined) {
                    cardNo = cardNo.replaceAll(' ','');
                }
                return cardNo;
            } else {
                cardNo = this.pt402ReqModel.cardNoDisp1 + this.pt402ReqModel.cardNoDisp2 + this.pt402ReqModel.cardNoDisp3 + this.pt402ReqModel.cardNoDisp4;
            }
            return cardNo;
        },
        expiryDate: function() {
            return this.pt402ReqModel.limitMonth + this.pt402ReqModel.limitYear;
        }

    }
}
</script>
